import { MutationCache, Query, QueryCache, QueryClient } from "@tanstack/react-query";

//py-components
import { toast } from "@performyard/py-components";

// Utils
import { formatErrorMessage } from "../utils/TanstackQueryErrorHandling";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 2, // 2 seconds
			retryOnMount: false,
		},
	},
	queryCache: new QueryCache({
		onError(error, query) {
			//default error handling has to be explicitly turned off within the useQuery hook
			// can be turned off by setting meta.disableDefaultErrorHandling to true
			if (!query?.meta?.disableDefaultErrorHandling) {
				const messages = formatErrorMessage(error, query as Query);

				messages.forEach((message) => {
					toast.error(message);
				});
			}
			return error;
		},
	}),
	mutationCache: new MutationCache({
		onError(error, _variables, context, mutation) {
			//default error handling has to be explicitly turned off within the useMutation hook
			// can be turned off by setting meta.disableDefaultErrorHandling to true
			if (!mutation?.options?.meta?.disableDefaultErrorHandling) {
				const messages = formatErrorMessage(error, context as Query);
				messages.forEach((message) => {
					toast.error(message);
				});
			}
			return error;
		},
	}),
});
